<template>
    <div>
        <title-component title="Usuarios" subtitle="Listado de usuarios"></title-component>
        <table-screen v-if="display.table == true" v-on:screen="Screen"></table-screen>
    </div>
</template>
<script>
import TitleComponent from '@/components/title.vue'
import TableScreen from './table.vue'
export default {
    components:{
        TitleComponent,
        TableScreen,
    },
    data() {
        return {
            display:{
                table:true,
                add:false,
                edit:false
            }
        };
    },
    mounted() {
        
    },
    methods: {
        Screen(item){
            this.display = item
        }
    },
};
</script>